import PermissionsTable from "../../Tables/RolesAndPermissions/Permissions/PermissionsTable";

const Permissions = () => {
  return <PermissionsTable />;
};

export default Permissions;
